var router = require('../services/router');

var messages = require('../components/messages');
const viewModel = require("../viewModel");

var Authorization = function () {
    var self = this;

    this.isAuthorized = ko.observable(false);

    this.setIsAuthorized = function (value) {
        self.isAuthorized(Boolean(value));
    };

    this.login = function (callback, data, vm) {
        messages.removeAllItems();

        $.ajax({
            url: 'rest.php/login',
            method: 'POST',
            data: data,
            dataType: 'json'
        }).done(function (resp) {
            if (resp.password_complexity_update_required) {
                location.href = "/service/change_password_required.php?src=bulk_po";
            } else {
                self.setIsAuthorized(true);
                if (callback) callback(true, resp.message);
            }
        }).fail(function (jqXHR, textStatus, error) {
            var error = jqXHR.responseJSON.error;
            var captcha = error.data;

            var viewModel = require('./../viewModel');
            viewModel.init();

            if (captcha) {
                viewModel.captcha('');
                viewModel.captcha(captcha.captcha);
            }

            if (error.code === 401) {
                router.goTo('login');
                self.setIsAuthorized(false);
            }

            messages.addItem(error.message);

            if (callback) callback(false, error.message);
        }).always(function () {

        });
    };

    this.logout = function (callback) {
        messages.removeAllItems();

        $.ajax({
            url: 'rest.php/logout',
            method: 'GET',
            dataType: 'json'
        }).done(function (resp) {
            self.setIsAuthorized(false);
            if (callback) callback(true);
        }).fail(function (jqXHR, textStatus, error) {
            var error = jqXHR.responseJSON.error;

            if (error.code === 401) {
                router.goTo('login');
                self.setIsAuthorized(false);
            }

            messages.addItem(error.message);

            if (callback) callback(false, error.message);
        }).always(function () {

        });
    };

    this.changePassword = function (callback, data) {
        messages.removeAllItems();

        $.ajax({
            url: 'rest.php/change_password',
            method: 'POST',
            data: data,
            dataType: 'json'
        }).done(function (resp) {
            if (callback) callback(true, resp && resp.message ? resp.message : '');
        }).fail(function (jqXHR, textStatus, error) {
            var error = jqXHR.responseJSON.error;

            if (error.code === 401) {
                router.goTo('login');
                self.setIsAuthorized(false);
            }

            messages.addItem(error.message);

            if (callback) callback(false, error.message);
        }).always(function () {

        });
    };

    this.requestAccount = function (callback, data) {
        messages.removeAllItems();

        $.ajax({
            url: 'rest.php/request_account',
            method: 'POST',
            data: data,
            dataType: 'json'
        }).done(function (resp) {
            self.setIsAuthorized(false);
            if (callback) callback(true);
        }).fail(function (jqXHR, textStatus, error) {
            var error = jqXHR.responseJSON.error;

            if (error.code === 401) {
                router.goTo('login');
                self.setIsAuthorized(false);
            }

            messages.addItem(error.message);

            if (callback) callback(false, error.message);
        }).always(function () {

        });
    };
    
    this.resetPassword = function (callback, data) {
        messages.removeAllItems();

        $.ajax({
            url: 'rest.php/reset_password',
            method: 'POST',
            data: data,
            dataType: 'json'
        }).done(function (resp) {
            if (callback) callback(true);
        }).fail(function (jqXHR, textStatus, error) {
            var error = jqXHR.responseJSON.error;

            if (error.code === 401) {
                router.goTo('login');
                self.setIsAuthorized(false);
            }

            messages.addItem(error.message);

            if (callback) callback(false, error.message);
        }).always(function () {

        });
    };
};

module.exports = new Authorization();



//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/services/authorization.js
// module id = 5
// module chunks = 0